import { normalize } from 'normalizr';

import { notify } from 'utils/reduxUtils';

import { notificationSchema } from './entities';

export const types = {
  ACKNOWLEDGE_NOTIFICATION_ERROR:
    'notifications/ACKNOWLEDGE_NOTIFICATION_ERROR',
  ACKNOWLEDGE_NOTIFICATION_REQUEST:
    'notifications/ACKNOWLEDGE_NOTIFICATION_REQUEST',
  ACKNOWLEDGE_NOTIFICATION_SUCCESS:
    'notifications/ACKNOWLEDGE_NOTIFICATION_SUCCESS',
  REMOVE_NOTIFICATIONS_FROM_PAGE_NOTIFICATION_IDS:
    'notifications/REMOVE_NOTIFICATIONS_FROM_PAGE_NOTIFICATION_IDS',
  ENTITIES_NOTIFICATIONS_RECEIVE:
    'notifications/ENTITIES_NOTIFICATIONS_RECEIVE',
  ENTITIES_LIST_NOTIFICATIONS_RECEIVE:
    'notifications/ENTITIES_LIST_NOTIFICATIONS_RECEIVE',
  ENTITIES_PAGE_NOTIFICATIONS_RECEIVE:
    'notifications/ENTITIES_PAGE_NOTIFICATIONS_RECEIVE',
  INIT_NOTIFICATIONS_ERROR: 'notifications/INIT_NOTIFICATIONS_ERROR',
  INIT_NOTIFICATIONS_REQUEST: 'notifications/INIT_NOTIFICATIONS_REQUEST',
  INIT_NOTIFICATIONS_SUCCESS: 'notifications/INIT_NOTIFICATIONS_SUCCESS',
  MARK_ALL_NOTIFICATIONS_READ_ERROR:
    'notifications/MARK_ALL_NOTIFICATIONS_READ_ERROR',
  MARK_ALL_NOTIFICATIONS_READ_REQUEST:
    'notifications/MARK_ALL_NOTIFICATIONS_READ_REQUEST',
  MARK_ALL_NOTIFICATIONS_READ_SUCCESS:
    'notifications/MARK_ALL_NOTIFICATIONS_READ_SUCCESS',
  NOTIFICATIONS_CONNECTION_INIT_STREAM:
    'notifications/NOTIFICATIONS_CONNECTION_INIT_STREAM',
};

export const acknowledgeNotification = {
  error: () => ({ type: types.ACKNOWLEDGE_NOTIFICATION_ERROR }),
  request: ({ notification }) => ({
    type: types.ACKNOWLEDGE_NOTIFICATION_REQUEST,
    payload: { notification },
  }),
  success: () => ({
    type: types.ACKNOWLEDGE_NOTIFICATION_SUCCESS,
  }),
};

export const entities = {
  receiveNotifications: (payload) => ({
    type: types.ENTITIES_NOTIFICATIONS_RECEIVE,
    payload: {
      ...normalize(payload, [notificationSchema]),
    },
  }),
};

export const initializeNotifications = {
  error: () => ({
    type: types.INIT_NOTIFICATIONS_ERROR,
  }),
  request: () => ({
    type: types.INIT_NOTIFICATIONS_REQUEST,
  }),
  success: () => ({
    type: types.INIT_NOTIFICATIONS_SUCCESS,
  }),
};

export const markAllNotificationsRead = {
  error: notify(
    (error) => ({
      type: types.MARK_ALL_NOTIFICATIONS_READ_ERROR,
      payload: error,
    }),
    'Failed to mark notifications as read',
  ),
  request: ({ callback }) => ({
    type: types.MARK_ALL_NOTIFICATIONS_READ_REQUEST,
    payload: { callback },
  }),
  success: () => ({
    type: types.MARK_ALL_NOTIFICATIONS_READ_SUCCESS,
  }),
};

export const notificationsConnection = {
  initStream: () => ({
    type: types.NOTIFICATIONS_CONNECTION_INIT_STREAM,
  }),
};

export const removeNotificationsFromPageNotificationIds = ({
  idsToRemove,
}) => ({
  type: types.REMOVE_NOTIFICATIONS_FROM_PAGE_NOTIFICATION_IDS,
  payload: { idsToRemove },
});
